// import React from "react";
// import ReactDOM from "react-dom";
// import { AuthProvider } from "./User/UserAuthContext/UserAuthContext";
// import App from "./App";
// import { BrowserRouter } from "react-router-dom";

// ReactDOM.render(
//   <AuthProvider>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </AuthProvider>,
//   document.getElementById("root")
// );
import React from "react";
import { createRoot } from 'react-dom/client';
import { AuthProvider } from "./User/UserAuthContext/UserAuthContext";
import App from "./App";
import { BrowserRouter } from "react-router-dom";


createRoot(document.getElementById('root')).render(
<AuthProvider>
     <BrowserRouter>
       <App />
     </BrowserRouter>
   </AuthProvider>,

);